/* eslint-disable import/prefer-default-export */
export const getRemainingTime = expiryTime => {
  const currentTime = new Date();
  const expiry = new Date(expiryTime);
  const diff = expiry.getTime() - currentTime.getTime();

  if (diff <= 0) {
    return { hours: 0, minutes: 0, expired: true };
  }

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  return { hours, minutes, expired: false };
};
